import { useEffect } from 'react';
import { Form, Input, InputNumber, Switch, Button } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';

export default function NationalityForm({ initialData, onSubmit, isLoading }: any) {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        countryCode2: initialData.countryCode2 || '',
        countryNameEn: initialData.countryNameEn || '',
        countryNameAr: initialData.countryNameAr || '',
        callingCode: initialData.callingCode || '',
        sortOrder: initialData.sortOrder ?? 0,
        active: initialData.active ?? true,
      });
    }
  }, [initialData, form]);

  const handleFinish = (values: any) => {
    onSubmit({ ...values, sortOrder: Number(values.sortOrder) });
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={{ countryCode2: '', countryNameEn: '', countryNameAr: '', callingCode: '', sortOrder: 0, active: true }} style={{ maxWidth: 480 }}>
      <Form.Item label={t('nationalities.code')} name="countryCode2" rules={[{ required: true }]}>
        <Input maxLength={2} placeholder="SA" />
      </Form.Item>
      <Form.Item label={t('nationalities.nameEn')} name="countryNameEn" rules={[{ required: true }]}>
        <Input placeholder="Saudi Arabia" />
      </Form.Item>
      <Form.Item label={t('nationalities.nameAr')} name="countryNameAr" rules={[{ required: true }]}>
        <Input dir="rtl" placeholder="المملكة العربية السعودية" />
      </Form.Item>
      <Form.Item label={t('nationalities.callingCode')} name="callingCode" rules={[{ required: true }]}>
        <Input placeholder="+966" />
      </Form.Item>
      <Form.Item label={t('nationalities.sortOrder')} name="sortOrder" rules={[{ required: true }]}>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label={t('common.active')} name="active" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>{t('common.save')}</Button>
      </Form.Item>
    </Form>
  );
}
